import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Routes } from 'react-router-dom';

//TAILWINDCSS + CUSTOM
import './index.css';

//JSX FILES TO ROUTE
import Home from './container/Home';
import Info from './container/Info';
import Buy from './container/buy/Buy';
import Card from './container/buy/Card';
import Confirm from './container/buy/Confirm';

ReactDOM.render(
  <HashRouter>
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/info' element={<Info />} />
      <Route path='/buy' element={<Buy />} />
      <Route path='/buy/card' element={<Card />} />
      <Route path='/buy/confirm' element={<Confirm />} />
    </Routes>
  </HashRouter>,
  document.getElementById('root'),
);

